import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizephrase',
})
export class TextCapitalize implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
